import "./PrivacyPolicy.module.css";
import Header from "@/reusable_sections/Header";
import Datacollectionnotice from "./sections/Datacollectionnotice";
import Transparency from "./sections/Transparency";
import TcpaCompliance from "./sections/TcpaCompliance";
import Tcpacompliance from "./sections/Tcpacompliance";
import Footer from "@/reusable_sections/Footer";
export default function PrivacyPolicyPage() {
  return <div>
      <Header />
      <Datacollectionnotice />
      <Transparency />
      <TcpaCompliance />
      <Tcpacompliance />
      <Footer />
    </div>;
}